import type { Handlers, Handler } from '../state';
import { blockquote } from './blockquote';
import { hardBreak } from './break';
import { code } from './code';
import { deleteNode } from './deleteNode';
import { emphasis } from './emphasis';
import { heading } from './heading';
import { image } from './image';
import { inlineCode } from './inlineCode';
import { link } from './link';
import { list } from './list';
import { listItem } from './listItem';
import { paragraph } from './paragraph';
import { root } from './root';
import { strong } from './strong';
import { table } from './table';
import { tableCell } from './tableCell';
import { tableRow } from './tableRow';
import { text } from './text';
import { thematicBreak } from './thematicBreak';

// asHandler casts a specific-subtype handler to the generic Handler type.
// This is safe: parseTokens only calls a handler with a node whose `type` matches the key.
// TypeScript cannot express this constraint without a cast due to function parameter
// contravariance — a handler accepting (node: Blockquote) is not assignable to one accepting
// (node: Content) even though we only ever call it with a Blockquote node.
const asHandler = <T>(
	fn: (state: Parameters<Handler>[0], node: T, index: number) => void,
): Handler => fn as unknown as Handler;

/** Default handlers for nodes. */
export const handlers: Handlers = {
	root: asHandler(root),
	blockquote: asHandler(blockquote),
	paragraph: asHandler(paragraph),
	heading: asHandler(heading),
	list: asHandler(list),
	listItem: asHandler(listItem),
	table: asHandler(table),
	tableRow: asHandler(tableRow),
	tableCell: asHandler(tableCell),
	code: asHandler(code),
	thematicBreak: asHandler(thematicBreak),
	break: asHandler(hardBreak),
	image: asHandler(image),
	text: asHandler(text),
	strong: asHandler(strong),
	emphasis: asHandler(emphasis),
	inlineCode: asHandler(inlineCode),
	link: asHandler(link),
	delete: asHandler(deleteNode),
};
